import { LucideArrowRight } from 'lucide-react';

type Props = {
  facilityName: string | null;
  customerName: string | null;
};

export const FromFacilityToCustomerLabel: React.FC<Props> = ({
  facilityName,
  customerName,
}) =>
  !facilityName || !customerName ? null : (
    <div className="flex flex-row items-center gap-2">
      <div className="text-base text-neutral/50">{facilityName}</div>
      <LucideArrowRight size={12} />
      <div className="text-base text-neutral/50">{customerName}</div>
    </div>
  );
